<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              email
            </v-icon>
            <span class="title">Data Pengajuan Surat</span>
          </v-card-title>
          <v-tabs
            v-model="tabsurat"
            background-color="primary"
            centered
            dark
            icons-and-text>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Pengajuan
              <v-icon large>playlist_add_check</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>playlist_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabsurat">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="4">
                        <v-select
                          :items="liststatus"
                          name="statussurat"
                          v-model="filter.status"
                          label="Status"
                          @change="getSurat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.tanggal_surat`]="{ item }">
                            {{ item.tanggal_surat | dateToAge }}
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <alertsp :alertdata="alertdata"></alertsp>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddsurat"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-select
                                :items="listjenissurat"
                                name="jenissurat"
                                v-model="addsurat.jenis_surat"
                                item-text="nama_js"
                                item-value="id_js"
                                return-object
                                @change="updateJenisSurat"
                                label="Jenis Surat">
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addsurat.deskripsi_surat"
                                auto-grow
                                label="Deskripsi Surat"
                                :rules="[rules.required]"
                                rows="1">
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-checkbox
                                v-model="checkbox"
                                :rules="[v => !!v || 'Setujui untuk melanjutkan!']"
                                :label="'Sebagai ' + username"
                                required>
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-btn
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'SuratGuest',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    api: process.env.VUE_APP_API,
    publickey: '123',
    liststatus: ['permohonan', 'proses', 'siap', 'selesai', 'batal'],
    filter: {
      search: '',
      status: 'permohonan',
    },
    headers: [
      { text: 'Kode', value: 'kode_surat' },
      { text: 'NIK', value: 'nik_surat' },
      { text: 'Jenis', value: 'nama_js' },
      { text: 'Tanggal', value: 'tanggal_surat' },
      { text: 'Status', value: 'status_surat' },
    ],
    datalist: [],
    listjenissurat: [],
    addsurat: {
      jenis_surat: '',
      jenis_surat_l: '',
      deskripsi_surat: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
    },
    tabsurat: null,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'username',
    ]),
  },
  mounted() {
    if (this.$route.query.type && this.$route.query.type !== '') {
      this.filter.status = this.$route.query.type;
    }
    this.getSurat();
    this.getJenisSurat();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    updateJenisSurat(data) {
      this.addsurat.jenis_surat = data.id_js;
      this.addsurat.jenis_surat_l = data.nama_js;
    },
    getJenisSurat() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenissurat/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listjenissurat = resdata.data;
                this.addsurat.jenis_surat = resdata.data[0].id_js;
                this.addsurat.jenis_surat_l = resdata.data[0].nama_js;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getSurat() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/surat/',
            {
              params: {
                status: this.filter.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddsurat.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/surat/',
              qs.stringify(
                this.addsurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddsurat.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.addsurat.jenis_surat_l + '" berhasil ditambahkan!';
                  this.getSurat();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
